import React, { useMemo } from 'react';

const NaComponent = ({ children }) => {
  const toRender = () => {
    if (typeof children === 'string' && children?.includes('N/A')) {
      return <div className="na-span">{children}</div>;
    }

    return children;
  };

  return <div>{toRender()}</div>;
};

export default NaComponent;
